var BaseMsgItem = require('./BaseMsgItem');
var $ = require('jQuery');
var template = require('./../../template/msg/card-msg-mutual.html');
var config = require('../../global/config');
var ActionType = require('../../constant/ActionType'); 
var dispatcher = require('../../global/dispatcher');

var CardMsgMutual = function (options) {
    (function(self){
        var defaults ={
            template:template
        };
        $.extend(defaults,options);
        BaseMsgItem.call(self,defaults);
    })(this);
};


CardMsgMutual.prototype = Object.create(BaseMsgItem.prototype);
CardMsgMutual.prototype.renderContent = function () {
  var self = this;
  var msg = this._data.msg;
  if (!msg) {
    return false;
  }
  //数据
  var content = msg.content;
  var element = this._element;
  var title = element.find('.im-mutual-title');
  var mutualText = element.find('.im-mutual-text');
  var normal =element.find('.im-mutual-normal');
  var detail = element.find('.im-mutual-detail');
  var img = element.find('.im-mutual-img');
  var a = element.find('.im-mutual-content');
  var moreicon = element.find('.im-mutual-btn');
  var userAgent = navigator.userAgent;
  var rMsie = /(msie\s|trident.*rv:)([\w.]+)/;

  if (userAgent.indexOf("Firefox") > -1 || !!window.ActiveXObject || ("ActiveXObject" in window)) { //判断是否Firefox浏览器
      detail.css('whiteSpace','nowrap')
      detail.css('display','block')
  }
  // content
  if (!content.card_action_url || content.card_action_url === '') {
    a.attr('href', 'javascript:;');
    a[0].addEventListener('click', function () {
      var text = '请在手机端58APP中查看详情';
      dispatcher.dispatch({
        type: ActionType.TOAST_SHOW,
        data: {
          content: text,
          interval: 2000
        }
      });
    })
  } else {
    a.attr('href', content.card_action_url);
  }

  // title
  if(content.card_title && content.card_title !==''){
    title.text(content.card_title);
  }else{
    title.css('display','none');
  }
 
  // detail
  if (content.card_content && content.card_content !== '') {
    detail.text(content.card_content);
  } else {
    detail.css('display', 'none');
  }
  //附加信息
  if(content.card_subContent && content.card_subContent !== ''){
    normal.text(content.card_subContent);
  } else {
    normal.css('display','none')
    normal.text('附加信息');
  }
  //图片
  if (content.card_picture_url && content.card_picture_url !== '') {
    img.attr('src', content.card_picture_url);
  } else {
    img.css('display', 'none');
    mutualText.css('margin-left','0px')
  }
  //按钮数组渲染:card_sub_btnTitle
  const labels = content.card_btnArray;
  if (labels && labels !== '') {
    let len = labels.length;
    let btnLen = len>4? 4:len
    for(let i=0;i<btnLen;i++){
      //按钮有地址
      if(labels[i].card_sub_btnUrl && labels[i].card_sub_btnUrl !== ''){
        moreicon.append($('<a class="btn-label"  href="'+labels[i].card_sub_btnUrl+'" target="_blank"></a>').text(labels[i].card_sub_btnTitle));
      }else{
        moreicon.append($('<a class="btn-label" href="javascript:void(0)"></a>').text(labels[i].card_sub_btnTitle));
      }
    }
  } else {
    moreicon.remove();
  }
  moreicon.click(function(e){
    console.log(e.target)
    $(e.target).attr("disabled",true).css({"background":"#3333","color":"white"});
  })
};

module.exports = CardMsgMutual;